"use client";

import { useEffect, useRef } from "react";

export default function useBackButtonClose(onClose: () => void) {
  const didPushRef = useRef(false);
  const firstCleanup = useRef(true);

  useEffect(() => {
    if (!didPushRef.current) {
      window.history.pushState({ modal: true }, "");
      didPushRef.current = true;
    }

    const handlePop = () => {
      onClose();
    };

    window.addEventListener("popstate", handlePop);

    return () => {
      window.removeEventListener("popstate", handlePop);

      if (firstCleanup.current) {
        firstCleanup.current = false;
        return;
      }

      if (didPushRef.current) {
        didPushRef.current = false;
      }
    };
  }, [onClose]);
}
